export const confirms = (value, target) => {
    if (value !== target) {
        return 'Пароли должны совпадать';
    }
    return null;
};
